import classNames from 'classnames'
import React from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip/Tooltip'

import styles from './Transactions.page.module.scss'

export interface TCardProps {
  title: string
  description?: string
  renderDescription?(): React.ReactNode
  buttonText: string
  buttonInfoText?: string
  additionalDescription?: string
  variant?: 'primary' | 'secondary'
  icon: React.ReactNode
  to?: string
  bottomSpaced?: boolean
  isLoading?: boolean
  lockAction?: boolean
  onClick?: () => void
}

export const Card: React.FC<TCardProps> = (props) => {
  const {
    title,
    buttonText,
    variant = 'secondary',
    icon,
    buttonInfoText,
    to,
    lockAction,
    isLoading = false,
  } = props
  const { description, renderDescription, additionalDescription, bottomSpaced } = props
  const { onClick } = props

  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (to) {
      navigate(to)
    }
  }

  return (
    <div className={styles.card}>
      <div className={styles.textBox}>
        {icon}
        {title && (
          <Heading6 className={styles.title} medium>
            {title}
          </Heading6>
        )}
        {description && (
          <div>
            <p className={styles.text}>{description}</p>
          </div>
        )}
        {renderDescription && <div className={styles.text}>{renderDescription()}</div>}
      </div>
      <div className={styles.actionBlock}>
        <Tooltip fullWidth content={buttonInfoText} disabled={!buttonInfoText || !lockAction}>
          <Button
            size='lg'
            fullWidth
            variant={variant}
            loading={isLoading}
            disabled={lockAction}
            onClick={handleClick}
          >
            {buttonText}
          </Button>
        </Tooltip>
        {(additionalDescription || bottomSpaced) && (
          <p
            className={classNames(styles.text, {
              [styles.bottomSpaced]: bottomSpaced,
            })}
          >
            {additionalDescription}
          </p>
        )}
      </div>
    </div>
  )
}
